import script from "./QuestionBank2.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionBank2.vue?vue&type=script&setup=true&lang=js"

import "./QuestionBank2.vue?vue&type=style&index=0&id=05331db3&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05331db3"]])

export default __exports__